import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import './file-tree-modal.scss'
import styles from './warning-modal.module.scss';

export const NoneKbWarningModal = (props: { onConfirm?: () => void; open?: boolean, onCancel?:() => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(props.open);
  }, [props.open]);

  const onCancel = () => {
    setIsOpen(false)
    props.onCancel?.()
  }

  const onConfirm = () => {
    setIsOpen(false)
    props.onConfirm?.()
  }

  return (
    <Modal footer={null} open={isOpen} width={368} onCancel={onCancel}>
      <div className={styles.noKbWarningModalContent}>
        <div className="top">
          <ExclamationCircleFilled style={{ marginRight: 8, color: '#FF8800', fontSize: 24 }} />
          <span>确定要切换模型吗？</span>
        </div>
        <div className="desc">根据当前组织策略，该模型无法连接知识库，是否确认切换？</div>
        <div className="buttons">
          <div className="cancel" onClick={() => setIsOpen(false)}>
            取消
          </div>
          <div className="confirm" onClick={onConfirm}>
            确定切换
          </div>
        </div>
      </div>
    </Modal>
  );
};
